import LegacyButton from './LegacyButton';
export default LegacyButton;
